import { render, staticRenderFns } from "./how-to-get.vue?vue&type=template&id=7cdf7099"
import script from "./how-to-get.vue?vue&type=script&lang=js"
export * from "./how-to-get.vue?vue&type=script&lang=js"
import style0 from "./how-to-get.vue?vue&type=style&index=0&id=7cdf7099&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports